const pagesOrganizationEn = {
  organization: "Organization",
  tabs: {
    overview: "Overview",
    chart: "Chart",
    history: "History",
    cost: "Cost",
    alert: "Alert",
    rulePolicy: "Rule & Policy",
    settings: "Settings",
  },
  components: {
    header: {
      noOrganizationInfo: "Organization information not found",
      countPeople: "people",
      level: "Level",
    },
    structureCard: {
      parentOrganizationUnit: "Parent Organization Unit",
      childOrganizationUnit: "Child Organization Unit",
    },
    adjacentDepartments: {
      parentDepartment: "Parent Department",
      childDepartment: "Child Department",
    },
    organizationToolbar: {
      mode: "mode",
      hierarchy: "Hierarchy",
      tree: "Tree",
      table: "Table",
      export: "Export",
      compactView: "Compact View",
    },
  },
  chartPage: {
    emptyState: {
      title: "No organization data available",
      description: "No valid organization data exists for the specified date.",
    },
    treeView: {
      countPeople: "people",
    },
    export: {
      generating_pdf: "Generating PDF...",
      error: "Failed to export PDF",
      success: "PDF export completed",
      successDescription: "The organization chart has been exported as a PDF.",
    },
  },
  detailPage: {
    people: "People",
    structure: "Structure",
    headerTabs: {
      detail: "Detail",
      history: "History",
    },
    statusBadge: {
      active: "Active",
      inactive: "Inactive",
    },
    peopleCardFilter: {
      filterByName: "Filter by name...",
      all: "All",
      employmentType: "Employment Type",
      allEmploymentTypes: "All Employment Types",
    },
  },
  settingPage: {
    hierarchySetting: {
      title: "Hierarchy Level",
      subTitle: "Level Settings",
      description:
        "The position of an organizational unit within the hierarchy is defined by its level value. A lower hierarchy level value corresponds to a higher-ranking organizational unit.",
      headers: {
        label: "Level Name",
        level: "Hierarchy Level",
      },
      addHierarchy: "Add Hierarchy Level",
      actions: {
        edit: "Edit",
        delete: "Delete",
      },
      editHierarchyDialog: {
        title: "Edit Hierarchy Level",
        addTitle: "Add Hierarchy Level",
        editTitle: "Edit Hierarchy Level",
        addDescription:
          "Add a new hierarchy level. Please enter the hierarchy name.",
        editDescription:
          "Are you sure you want to edit this hierarchy level? This action cannot be undone.",
        description:
          "Are you sure you want to edit this hierarchy level? This action cannot be undone.",
        label: "Level Name",
        level: "Hierarchy Level",
        placeholder: "Enter the name of the hierarchy level",
        success: "Hierarchy level edited successfully",
        confirm: "Edit",
        addConfirm: "Add",
        editConfirm: "Save",
        cancel: "Cancel",
      },
      deleteHierarchyDialog: {
        title: "Delete Hierarchy Level",
        description:
          "Are you sure you want to delete this hierarchy level? This action cannot be undone.",
        success: "Hierarchy level deleted successfully",
        confirm: "Delete",
        cancel: "Cancel",
      },
    },
  },
  plan: {
    title: "Organization Planning",
    cantEditBecauseConfirmed:
      "This plan has been confirmed and cannot be edited.",
    components: {
      statusBadge: {
        inProgress: "Draft",
        approved: "Confirmed",
        archived: "Archived",
      },
    },
    tabs: {
      plan: "Plan",
    },
    emptyState: {
      noOrganizationPlans: "No organization plans",
      createOrganizationPlan: "Create organization plan",
    },
    detailPage: {
      tabs: {
        organizationUnit: "Organization Unit",
        settings: "Settings",
      },
      effectiveDate: "Effective Date",
      draft: "Draft",
      confirmed: "Confirmed",
      editDialog: {
        title: "Organization Plan Info",
        name: "Name",
        effectiveDate: "Effective Date",
      },
      addOrganizationUnit: "Add organization unit",
      completeDialog: {
        description:
          "This operation cannot be undone. Are you sure you want to confirm?",
      },
    },
    addOrEditOrgUnit: {
      addTitle: "Add Organization Unit",
      editTitle: "Edit Organization Unit",
      step1AddingProcess: {
        title: "Adding Process",
        establishNewFromScratch:
          "Establish a new organization unit from scratch",
        establishNewByDuplicating:
          "Establish a new organization unit by duplicating data from an existing organization unit",
        establishNewByDuplicatingDescription:
          "Duplicate the data of the source organizational unit to establish a new organization unit. Its history and organization unit IDs will not be carried over. This adding process is useful when launching a new organization unit if a similar organization unit exists.",
        sourceOrganizationUnit: "The source organization unit",
        abolishSourceOrganizationUnit: "Abolish the source organization unit",
      },
      step1UpdateProcess: {
        title: "Editing Process",
        transfer: "Transfer",
        transferDescription:
          "The new organization unit inherits all data from the selected organization unit. Since the ID of the organizational unit does not change, the history will also be carried over.",
        abolish: "Abolish",
        abolishDescription:
          "This will remove the selected organization unit from the organization. It will remain as a abolished organization unit, so the data in the system will not be lost.",
      },
      step2OrgUnitName: {
        title: "Organization Unit Name",
        name: "Name",
        shortName: "Short Name",
        businessCardName: "Business Card Name",
      },
      step3OrgUnitInfo: {
        title: "Organization Unit Info",
        code: "Code",
        office: "Office",
      },
      step4PurposeRole: {
        title: "Purpose & Role",
        description: "Description",
        functionalRole: "Functional Role",
        mission: "Mission",
      },
      step5Structure: {
        title: "Structure",
        parentOrganizationUnit: "Parent Organization Unit",
        hierarchyLevel: "Hierarchy Level",
        orderInHierarchy: "Display Order",
        childOrganizationUnit: "Child Organization Unit",
        addChildOrganizationUnit: "Add Child Organization Unit",
      },
      step6People: {
        title: "People",
        organizationUnitRole: "Organization Unit Role",
        departmentHead: "Department Head",
        deputyHead: "Deputy Head",
        assignedBy: "Assigned By",
        roleName: "Role Name",
        organizationUnitPersonnel: "Organization Unit Personnel",
        addPerson: "Add Person",
        noPerson: "No Person",
        peopleIncluded: "people included",
        representativeType: "Representative Type",
        addUnit: "Add organization unit",
        setPrimary: "Set Primary Organization Unit",
        pleaseSelect:
          "Please select the main organizational unit this user belongs to.",
        addPosition: "Add Position",
        pleaseSelectPosition:
          "Please select the position this member belongs to.",
      },
    },
    create: {
      title: "Create Organization Plan",
      steps: {
        organizationPlanInfo: "Organization Plan Info",
      },
      organizationPlanInfoStep: {
        title: "1. Organization Plan Info",
        name: "Name",
        effectiveDate: "Effective Date",
      },
    },
  },
};
export default pagesOrganizationEn;
